export default {
  // 菜單項
  home: "首頁",
  helpCenter: "幫助中心",

  // 幫助中心子菜單
  productFunction: "產品功能介紹",
  nationalInvolvement: "司法判例參考",
  prosecuteBook: "起訴書",
  policyRegulation: "政策法規",
  blockchainKnowledge: "區塊鏈行業知識",
  blockchainCaseInvestigation: "區塊鏈案件偵查實錄",

  // 數據大屏
  dataScreen: "數據大屏",

  // 用戶下拉菜單
  userCenter: "用戶中心",
  userFeedback: "用戶反饋",
  logout: "退出登錄",

  // 角色
  systemAdmin: "系統管理員",

  // 默認值
  noPhoneNumber: "暫無號碼",
};
